Vue.component("events-calendar", {
  data: function () {
    return {
      monthRuLang: [
        "Январь",
        "Февраль",
        "Март",
        "Апрель",
        "Май",
        "Июнь",
        "Июль",
        "Август",
        "Сентябрь",
        "Октябрь",
        "Ноябрь",
        "Декабрь",
      ],
      dayName: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
      daySliderItemsCount: 0,
      daySlideItemWidth: 32,
      daySlideItemMargin: 7,
      selectedYear: new Date().getFullYear(),
      selectedMonth: new Date().getMonth(),
      selectedDay: new Date().getDate(),
    };
  },
  methods: {
    updateToday() {},
    initSlickDays(reinitWithoutConditions = false) {
      const tmpWidth = $(this.$refs.calendar__days).innerWidth(),
        tmpDayWidth = this.daySlideItemWidth + this.daySlideItemMargin * 2, // 32 + 7 + 7;
        cnt = Math.floor(tmpWidth / tmpDayWidth);

      if (this.daySliderItemsCount !== cnt || reinitWithoutConditions) {
        if ($(this.$refs.calendar__days).hasClass("slick-initialized")) {
          $(this.$refs.calendar__days).slick("unslick");
        }
        setTimeout(() => {
          $(this.$refs.calendar__days).slick({
            slidesToShow: cnt,
            slidesToScroll: cnt,
            infinite: false,
            prevArrow:
              '<div class="slick-prev"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M14,19c-0.3,0-0.5-0.1-0.7-0.3l-6-6c-0.4-0.4-0.4-1,0-1.4l6-6c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L9.4,12l5.3,5.3c0.4,0.4,0.4,1,0,1.4C14.5,18.9,14.3,19,14,19z"/></svg></div>',
              // '<div class="slick-prev"><svg><use xlink:href="/assets/img/sprite.svg#chevron-left"></svg></div>',
            nextArrow:
              '<div class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M9,19c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l5.3-5.3L8.3,6.7c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l6,6c0.4,0.4,0.4,1,0,1.4l-6,6C9.5,18.9,9.3,19,9,19z"/></svg></div>',
              // '<div class="slick-next"><svg><use xlink:href="/assets/img/sprite.svg#chevron-right"></svg></div>',
          });

          if (this.selectedDay)
            $(this.$refs.calendar__days).slick(
              "slickGoTo",
              this.selectedDay - 1
            );
        }, 10);

        this.daySliderItemsCount = cnt;
      }
    },
  },
  watch: {
    selectedMonth: function (curVal, olVal) {
      this.initSlickDays(true);
      this.selectedDay =
        curVal == new Date().getMonth() ? new Date().getDate() : null;
    },
  },
  computed: {
    monthDays: function () {
      let res = [];
      const daysCount = new Date(
        this.selectedYear,
        this.selectedMonth + 1,
        0
      ).getDate();

      let day;
      for (let i = 0; i < daysCount; i++) {
        day = new Date(this.selectedYear, this.selectedMonth, i + 1).getDay();
        res.push({ date: i + 1, dayName: this.dayName[day], day });
      }

      return res;
    },
  },
  template: `
      <div class="calendar-control">
      <custom-select
       :select-options="monthRuLang"
       :selected-id="selectedMonth"
       :callback="(id) => this.selectedMonth = id"
       ></custom-select>
      <div
        :style="'margin: 0 -'+daySlideItemMargin+'px;'"
        class="calendar__days-wrapper"
      >
        <div
          ref="calendar__days"
          class="calendar__days"
        >
          <div
            v-for="(day, index) in monthDays"
            :key="'day-'+index"
            @click="() => selectedDay = day.date"
            :class="{
              'day-selected' : (selectedDay == day.date),
              'day-holiday' : (day.day == 0 || day.day == 6)
            }"
            class="day"
            style="margin: 0 ${this.daySlideItemMargin}px;"
          >
            <div class="day__date">{{ day.date }}</div>
            <div class="day__week-day">{{ day.dayName }}</div>
          </div>
        </div>
      </div>
    </div>`,

  mounted() {
    this.$nextTick(() => {
      this.initSlickDays();
    });

    window.addEventListener("resize", () => {
      this.initSlickDays();
    });
  },
});
